
/* eslint-disable  require-await,no-param-reassign,multiline-ternary,no-underscore-dangle,no-inline-comments,line-comment-position,no-use-before-define */
import {
  defineComponent, shallowRef, onMounted,ref,onUnmounted, reactive,
  nextTick,
} from 'vue';
import moment from 'moment';
import popWin from '@/pages/APicturePage/components/popWin.vue';

import {
  queryInfoByIssue, queryAllCompany,
} from './hotspotGridReq';

import { postRequest, } from '@/request/request';
import leftDialogVue from './components/leftDialog.vue';
import rightDialogVue from './components/rightDialog.vue';
import menuH from '@/components/menuH.vue';
import switchControl from '@/components/mapComonents/switchControl.vue';
import { getTimePlayerTenMinsPerm, } from '@/utils/tools';
import GDMap from '@/utils/AMapNew/amap';
import { getMapZoom, } from '@/utils/index';
import { useStore, } from 'vuex';
import { nodeTypeMap, } from '@/configs/mapConfig';
import switchParamConfig from '@/pages/APicturePage/switchParamConfig';
import { getShowKeysByType, } from '@/pages/logged/pages/supervise/pollution.config';
import { getJiaoZuoArea, } from '@/pages/APicturePage/APicturePageReq';

export default defineComponent({
  components: {
    popWin,
    leftDialogVue,
    rightDialogVue,
    menuH,
    switchControl,
  },
  setup () {
    const store = useStore();
    const { userInfo, } = store.state.login;
    // 登录人地区信息（数组，可包含多个地区，默认展示第一个）
    const { regionInfos, } = userInfo;
    const {
      regionLevel, country, city, county, longitudeCenter ,latitudeCenter, id,
    } = regionInfos[0];

    interface aMap {
      [propName: string]: any;
    }

    interface grid {
      [propName: string]: any;
    }

    const AMapView = shallowRef<aMap>({});
    // 选中的网格数据
    const activeGrid = ref<any>({});
    // 选中的网格索引
    const activeGridIndex = ref<number>(-1);
    const mapStyle = ref('darkVector');
    const activeTabNum = ref<number>(1);
    const leftDialogVueRef = ref<any>();
    const rightDialogVueRef = ref<any>();
    const playtingTime = ref('');
    // Switch控制组件对象
    const switchControlRef = ref<any>();
    const isClustererMarks = ref(true);
    const gridDetailData = ref<grid>({});
    // 右侧面板显隐
    const showRightPanel = ref<boolean>(false);
    // 选中的网格格点数据
    const mapCheckGrid = ref<grid>({});
    const mapElementSelected = ref<any>();
    const isSelectedMenu = ref(true);
    // switch组件点击时传出参数
    const switchInfoCurrSelected = ref<any>();
    const mapWidth = reactive({
      mapLeftWidth: '23.98%',
      mapRightWidth: '0',
    });
    const multipleDataCaches = reactive({
      country: { type: 1, isChecked: true, data: {}, },
      province: { type: 2, isChecked: false, data: {}, },
      city: { type: 3, isChecked: false, data: {}, },
      micro: { type: 4, isChecked: false, data: {}, },
      company: { isChecked: false, data: [], },
      cookingFume: { isChecked: false, data: {}, },
      construction: { isChecked: false, data: {}, },
      cookingFumeList: { isChecked: false, data: {}, },
      constructionList: { isChecked: false, data: {}, },
      companyList: { isChecked: false, data: {}, },
      exceed: { isChecked: false, data: {}, },
      yard: { isChecked: false, data: {}, },
      park: { isChecked: false, data: {}, },
      repair: { isChecked: false, data: {}, },
      boiler: { isChecked: false, data: {}, },
      furnace: { isChecked: false, data: {}, },
      yardList: { isChecked: false, data: {}, },
      parkList: { isChecked: false, data: {}, },
      muckParkList: { isChecked: false, data: {}, },
      repairList: { isChecked: false, data: {}, },
      boilerList: { isChecked: false, data: {}, },
      furnaceList: { isChecked: false, data: {}, },
      oilList: { isChecked: false, data: {}, },
    });
    const title = ref('热点网格分布');

    // const mapNum = ref<number>(0);
    const mapContainerWidth = ref<string>('40%');
    // 站点弹框
    const popupRef = ref<any>(null);
    // 当前弹窗部分数据
    const popInfo = {
      // 弹窗类型
      type: '',
      // 站点id
      id: '',
      // 基本信息
      info: {},
    };
    // 是否为焦作账号的标志位 true: 焦作账号 false: 其他账号
    const timePlayerTenMinsPerm = ref(getTimePlayerTenMinsPerm(userInfo));

    const moveCallback = () => {
      showMarkerClusterers();
    };

    // 初始化高德地图
    const initAMap = () => {
      AMapView.value = new GDMap(
        'hot-grid-container',
        [longitudeCenter, latitudeCenter,],
        getMapZoom(regionLevel),
        [5, 20,],
        '2D',
        moveCallback
      );
    };

    /**
     * 高德地图添加边界
     * @param {string} area 地区名
     * @returns {void}
     */
    const fake = async (area: string) => {
      if (area === '焦作市') {
        const polygon:any = await getJiaoZuoArea();

        AMapView.value.setJiaoZuoPolygonByArea(polygon.data);
      } else {
        AMap.plugin(['AMap.DistrictSearch',], () => {
          new AMap.DistrictSearch({
            extensions: 'all',
            subdistrict: 0,
          }).search(area, (status: any, result: any) => {
          // 外多边形坐标数组和内多边形坐标数组
            const outer = [
              new AMap.LngLat(-360, 90, true),
              new AMap.LngLat(-360, -90, true),
              new AMap.LngLat(360, -90, true),
              new AMap.LngLat(360, 90, true),
            ];
            const holes = result.districtList[0].boundaries;

            const pathArray = [
              outer,
            ];

            pathArray.push(...holes);
            const polygon = new AMap.Polygon({
              pathL: pathArray,
              strokeColor: '#eb5d5f',
              strokeWeight: 2,
              fillColor: '#151B28',
              fillOpacity: 0.1,
            });

            polygon.setPath(pathArray);
            AMapView.value.add(polygon);
          });
        });
      }
    };

    const mapChecked = () => {
      const _mapCheckGrid = mapCheckGrid.value;

      if (Object.keys(_mapCheckGrid).length && gridDetailData.value.length > 0) {
        if (rightDialogVueRef.value.isScroll) {
          // 调用子组件滑动到指定地方
          rightDialogVueRef.value.scroll(_mapCheckGrid.index * 368);
        }
        gridDetailData.value.forEach((item:Record<string, unknown>,index:number) => {
          if (item.id === _mapCheckGrid.id) {
            activeGridIndex.value = index;
          }
        });
      } else {
        activeGridIndex.value = -1;
        // activeGrid.value = null;
        activeGrid.value = {};
      }
    };

    // 监控企业是否显示
    const allCompanyShowFlag = ref(false);

    const clearClustererDataByType = (type: string) => {
      AMapView.value.clearMarkerClusterer(type);
    };

    // 高值污染源站点绘制
    const setExceedMarker = (key:string) => {
      if (!multipleDataCaches.exceed.isChecked || multipleDataCaches[key]?.isChecked || !multipleDataCaches.exceed.data[key]?.isChecked) {
        return;
      }
      const { data: list, } = multipleDataCaches.exceed.data[key];

      if (list && list.length > 0) {
        AMapView.value.clearMarkerClusterer(key);
        AMapView.value.showMarkerClusterer(
          mapElementSelected,
          list,
          key,
          isClustererMarks.value,
          siteInfoShow
        );
      }
    };

    /*
     *  地图图层切换处理--清除不需要的图层--工具栏上部图层互斥
     * 上下工具栏的图层可能兼容
     */
    const clearMapLayersByType = (type: string) => {
      switch (type) {
      case 'cluster':
        isClustererMarks.value = !isClustererMarks.value;
        showMarkerClusterers();
        break;
      case 'country':
        multipleDataCaches[type].isChecked = false;
        clearClustererDataByType(type);
        break;
      case 'province':
        multipleDataCaches[type].isChecked = false;
        clearClustererDataByType(type);
        break;
      case 'city':
        multipleDataCaches[type].isChecked = false;
        clearClustererDataByType(type);
        break;
      case 'micro':
        multipleDataCaches[type].isChecked = false;
        clearClustererDataByType(type);
        break;
      case 'company':
        multipleDataCaches[type].isChecked = false;
        multipleDataCaches[type].data = [];
        clearClustererDataByType(type);
        break;
      case 'cookingFume':
        multipleDataCaches[type].isChecked = false;
        multipleDataCaches[type].data = {};
        clearClustererDataByType(type);
        setExceedMarker(type);
        break;
      case 'construction':
        multipleDataCaches[type].isChecked = false;
        multipleDataCaches[type].data = {};
        clearClustererDataByType(type);
        setExceedMarker(type);
        break;
      case 'repair':
        multipleDataCaches[type].isChecked = false;
        multipleDataCaches[type].data = {};
        clearClustererDataByType(type);
        setExceedMarker(type);
        break;
      case 'yard':
        multipleDataCaches[type].isChecked = false;
        multipleDataCaches[type].data = {};
        clearClustererDataByType(type);
        setExceedMarker(type);
        break;
      case 'park':
        multipleDataCaches[type].isChecked = false;
        multipleDataCaches[type].data = {};
        clearClustererDataByType(type);
        setExceedMarker(type);
        break;
      case 'cookingFumeList':
        multipleDataCaches[type].isChecked = false;
        multipleDataCaches[type].data = {};
        clearClustererDataByType(type);
        setExceedMarker(type);
        break;
      case 'constructionList':
        multipleDataCaches[type].isChecked = false;
        multipleDataCaches[type].data = {};
        clearClustererDataByType(type);
        setExceedMarker(type);
        break;
      case 'companyList':
        multipleDataCaches[type].isChecked = false;
        multipleDataCaches[type].data = {};
        clearClustererDataByType(type);
        setExceedMarker(type);
        break;
      case 'repairList':
        multipleDataCaches[type].isChecked = false;
        multipleDataCaches[type].data = {};
        clearClustererDataByType(type);
        setExceedMarker(type);
        break;
      case 'yardList':
        multipleDataCaches[type].isChecked = false;
        multipleDataCaches[type].data = {};
        clearClustererDataByType(type);
        setExceedMarker(type);
        break;
      case 'parkList':
        multipleDataCaches[type].isChecked = false;
        multipleDataCaches[type].data = {};
        clearClustererDataByType(type);
        setExceedMarker(type);
        break;
      case 'muckParkList':
        multipleDataCaches[type].isChecked = false;
        multipleDataCaches[type].data = {};
        clearClustererDataByType(type);
        setExceedMarker(type);
        break;
      case 'boiler':
        multipleDataCaches[type].isChecked = false;
        multipleDataCaches[type].data = {};
        clearClustererDataByType(type);
        setExceedMarker(type);
        break;
      case 'boilerList':
        multipleDataCaches[type].isChecked = false;
        multipleDataCaches[type].data = {};
        clearClustererDataByType(type);
        setExceedMarker(type);
        break;
      case 'furnace':
        multipleDataCaches[type].isChecked = false;
        multipleDataCaches[type].data = {};
        clearClustererDataByType(type);
        setExceedMarker(type);
        break;
      case 'furnaceList':
        multipleDataCaches[type].isChecked = false;
        multipleDataCaches[type].data = {};
        clearClustererDataByType(type);
        setExceedMarker(type);
        break;
      case 'oilList':
        multipleDataCaches[type].isChecked = false;
        multipleDataCaches[type].data = {};
        clearClustererDataByType(type);
        setExceedMarker(type);
        break;
      default:
        break;
      }
    };

    const checkLayerCloseState = (type: string) => {
      const caseType =
        type === 'mapTools' ?
          mapElementSelected.value.parent :
          switchInfoCurrSelected.value.key;

      clearMapLayersByType(caseType);
    };

    // 通过右下角工具栏点击，显示各种数据的显示和关闭
    const switchChange = (switchParam: any) => {
      switchInfoCurrSelected.value = switchParam;
      if (switchParam.isChecked) {
        getDatasByType('switch');
      } else {
        checkLayerCloseState('switch');
      }
      closeWinInfo(switchParam.parent);
    };

    const showMarkerClusterers = () => {
      const reportTime = moment(playtingTime.value, 'YYYYMMDDHHmm').format('YYYYMMDDHH');

      Object.keys(multipleDataCaches).forEach((key) => {
        // 判断是否选中显示状态
        if (!multipleDataCaches[key].isChecked || !multipleDataCaches[key].data) {
          return;
        }

        let list = multipleDataCaches[key].data[reportTime];

        // 判断最新播放时间没有数据，选择播放数据中最近批次数据
        list = getLatestValidData(multipleDataCaches[key].data, reportTime, 0);

        if (key === 'company') {
          list = multipleDataCaches[key].data;
        }

        const viewList = AMapView.value.filterListByScreenViews(list);

        if (viewList && viewList.length > 0) {
          AMapView.value.clearMarkerClusterer(key);
          AMapView.value.showMarkerClusterer(
            mapElementSelected,
            viewList,
            key,
            isClustererMarks.value,
            siteInfoShow
          );
        }
      });
    };

    /**
     *  监控企业中选中相应网格的疑似企业标亮
     * @param {any} data 选中相应网格的疑似企业
     * @return {void}
     */
    const selectCompany = (data: any[]) => {
      if (data?.length && activeTabNum.value === 1) {
        if (allCompanyShowFlag.value) {
          // 若显示所有企业 需要重置marker状态
          AMapView.value.resMarkIconAllByType('company');
        } else {
          // 若没有显示所有企业 则需要先将疑似企业显示
          showCompanyMarker(data);
        }
        // 高亮企业
        highLightMarker(data);
      }
    };

    /**
     * @desc 显示企业点位
     * @param data 企业列表
     * @param cluster 是否聚合 企业监测默认不聚合
     */
    const showCompanyMarker = (data: any[], cluster = false) => {
      const TYPE = 'company';

      AMapView.value.showMarkerClusterer(
        mapElementSelected,
        data,
        TYPE,
        cluster,
        siteInfoShow
      );
    };

    /**
     * @desc 高亮显示点位信息
     * @param data 企业列表
     */
    const highLightMarker = (data: any[]) => {
      /* eslint-disable-next-line  no-restricted-syntax */
      for (const item of data) {
        AMapView.value.setMarkIconHighLight('company', item.id, [item.lon, item.lat,]);
      }
    };

    /**
     * @desc 取消显示所有企业marker 或 取消高亮图标但保持显示企业
     */
    const closeOrCancel = () => {
      if (allCompanyShowFlag.value) {
        // 重置所有marker
        AMapView.value.resMarkIconAllByType('company');
      } else {
        // 取消显示所有企业marker
        AMapView.value.clearMarkerClusterer('company');
      }
    };

    // 判断最新播放时间没有数据，选择播放数据中最近批次数据,最多推三个小时
    const getLatestValidData = (data: any, reportTime: string, count: number): any => {
      for (let i = 1; i <= 4; i++) {
        const retime = moment(moment(reportTime, 'YYYYMMDDHHmm')).subtract(i, 'hours').format('YYYYMMDDHH');

        if (data[retime]) {
          return data[retime];
        }
      }

      return null;
    };

    const showPMDataByType = (type: string) => {
      multipleDataCaches[type].isChecked = true;
      const pmDatas = multipleDataCaches[type].data;

      const reportTime = moment(playtingTime.value, 'YYYYMMDDHHmm').format('YYYYMMDDHH');

      let list = pmDatas[reportTime];

      // 判断最新播放时间没有数据，选择播放数据中最近批次数据
      list = getLatestValidData(multipleDataCaches[type].data, reportTime, 0);

      const viewList = AMapView.value.filterListByScreenViews(list);

      if (viewList && viewList.length > 0) {
        AMapView.value.showMarkerClusterer(
          mapElementSelected,
          viewList,
          type,
          isClustererMarks.value,
          siteInfoShow
        );
      }
    };

    // 展示地图弹出框
    const siteInfoShow = (markInfo: any, nodeType: any) => {
      markInfo.showType = mapElementSelected.value.type;

      // 缓存当前弹窗id和类型
      popInfo.id = markInfo.id;
      popInfo.type = nodeType;
      popInfo.info = { ...markInfo, };

      const { position, } = markInfo;

      AMapView.value.addInfoWin(popupRef.value.$el, [50, -40,]);

      // 判断是清单污染源 切换渲染弹窗
      if (switchParamConfig[nodeType] && nodeType.includes('List')) {
        /* eslint-disable no-shadow,lines-around-comment */
        const { tabletype, type, } = markInfo;
        const regionId = regionInfos[0].id;
        /**
         * headers: 重要信息
         * others: 详情信息
         * book: 联系人信息
         */
        const { headers, others, book, } = getShowKeysByType(tabletype,type,regionId);
        // 后端接口字段未统一为name的情况下  将companyName -> name
        const blackList = ['cookingFumeList',];
        const commonComponentName = 'commonList';
        const baseInfo = markInfo;

        if (blackList.includes(nodeType)) {
          baseInfo.name = baseInfo.companyName;
        }

        /**
         * 调用子组件暴露的方法 代替props传参 为保持一致性延续使用
         * nodeType转换为常量commonList，共用一个组件
         */
        popupRef.value.setInfoValue({
          baseInfo, nodeType: commonComponentName, headers, others, book,
        });
        nextTick(() => {
          AMapView.value.showInfoWin(true, position);
        });
      } else {
        popupRef.value.setInfoValue({
          popupData: {
            ...markInfo,
            infoWinType: nodeType,
            nodeType: nodeTypeMap.get(nodeType),
            currentTime: playtingTime.value,
          },
        });
        AMapView.value.showInfoWin(true, position);
      }
    };

    // 获取站点数据
    const getPMList = (elementParams: any) => {
      Object.keys(multipleDataCaches).forEach((key) => {
        if (multipleDataCaches[key].type) {
          getCurrentPMByType(key, multipleDataCaches[key].type, elementParams);
        }
      });
    };

    /*
     *  通过类型获取历史站点数据
     * key:站点名称 国、省、市、微、=> country、province、city、micro
     * pmType：站点类型 1234
     * elementParams:要素
     */
    const getCurrentPMByType = async (key: string, pmType: number, elementParams: any) => {
      playtingTime.value = moment(moment().format('YYYYMMDDHH00'), 'YYYYMMDDHHmmss').format('YYYYMMDDHHmmss');
      const times = {
        startTime: moment(playtingTime.value, 'YYYYMMDDHHmm').subtract(2, 'day').format('YYYYMMDD0000'),
        endTime: playtingTime.value,
        type: '3days',
      };
      const params = {
        stationType: pmType,
        startTime: moment(times.startTime, 'YYYYMMDDHHmmss').format('yyyyMMDDHH0000'),
        endTime: moment(times.endTime, 'YYYYMMDDHHmmss').format('yyyyMMDDHH0000'),
      };

      await postRequest('/gaochun/airMap/airStationForTimes', params).then((res:any) => {
        multipleDataCaches[key].data = res.data;
        showMarkerClusterers();
      });
    };

    const getOthersSiteDatasByType = (type:string) => {
      const { url, param, } = switchParamConfig[type];

      postRequest(url,param).then((res: any) => {
        let data = [];

        const isDataStructuralChanges = res.data?.constructor === Object;

        if (isDataStructuralChanges) {
          data = res.data.list;
        } else {
          data = res.data;
        }
        if (data && data.length) {
          multipleDataCaches[type].isChecked = true;
          multipleDataCaches[type].data = data;
          // 站点插值图不初始化时间轴
          const viewList = AMapView.value.filterListByScreenViews(
            multipleDataCaches[type].data
          );

          if (viewList && viewList.length > 0) {
            AMapView.value.clearMarkerClusterer(type);
            AMapView.value.showMarkerClusterer(
              mapElementSelected,
              viewList,
              type,
              isClustererMarks.value,
              siteInfoShow
            );
          }
        }
      });
    };

    /*
     * 根据类型获取数据
     * 一级菜单类型 站点pm、卫星satellite、沙尘dust、气象weatherForecast、雷达radar
     * type=mapTools 是右上侧工具栏切换
     * type=Switch 是右下组件进行各种类型数据显示
     */
    const getDatasByType = (type: string) => {
      const caseType =
        type === 'mapTools' ?
          mapElementSelected.value.parent :
          switchInfoCurrSelected.value.key;

      switch (caseType) {
      case 'cluster':
        isClustererMarks.value = !isClustererMarks.value;
        showMarkerClusterers();
        showCompanyClusterers();
        break;
      case 'country':
        showPMDataByType(switchInfoCurrSelected.value.key);
        break;
      case 'province':
        showPMDataByType(switchInfoCurrSelected.value.key);
        break;
      case 'city':
        showPMDataByType(switchInfoCurrSelected.value.key);
        break;
      case 'micro':
        showPMDataByType(switchInfoCurrSelected.value.key);
        break;
      case 'cookingFume':
        getOthersSiteDatasByType(switchInfoCurrSelected.value.key);
        break;
      case 'construction':
        getOthersSiteDatasByType(switchInfoCurrSelected.value.key);
        break;
      case 'company':
        getOthersSiteDatasByType(switchInfoCurrSelected.value.key);
        break;
      case 'cookingFumeList':
        getOthersSiteDatasByType(switchInfoCurrSelected.value.key);
        break;
      case 'constructionList':
        getOthersSiteDatasByType(switchInfoCurrSelected.value.key);
        break;
      case 'companyList':
        getOthersSiteDatasByType(switchInfoCurrSelected.value.key);
        break;
      case 'yard':
        getOthersSiteDatasByType(switchInfoCurrSelected.value.key);
        break;
      case 'park':
        getOthersSiteDatasByType(switchInfoCurrSelected.value.key);
        break;
      case 'repair':
        getOthersSiteDatasByType(switchInfoCurrSelected.value.key);
        break;
      case 'boiler':
        getOthersSiteDatasByType(switchInfoCurrSelected.value.key);
        break;
      case 'furnace':
        getOthersSiteDatasByType(switchInfoCurrSelected.value.key);
        break;
      case 'yardList':
        getOthersSiteDatasByType(switchInfoCurrSelected.value.key);
        break;
      case 'parkList':
        getOthersSiteDatasByType(switchInfoCurrSelected.value.key);
        break;
      case 'muckParkList':
        getOthersSiteDatasByType(switchInfoCurrSelected.value.key);
        break;
      case 'repairList':
        getOthersSiteDatasByType(switchInfoCurrSelected.value.key);
        break;
      case 'boilerList':
        getOthersSiteDatasByType(switchInfoCurrSelected.value.key);
        break;
      case 'furnaceList':
        getOthersSiteDatasByType(switchInfoCurrSelected.value.key);
        break;
      case 'oilList':
        getOthersSiteDatasByType(switchInfoCurrSelected.value.key);
        break;
      default:
        break;
      }
    };

    // 根据条件关闭地图弹窗
    const closeWinInfo = (indexName?: string) => {
      // 切换某些菜单关闭弹窗
      const closeTyps = [
        'pm',
        'satellite',
        'radar',
        'weatherForecast',
        'dust',
        'cluster',
      ];

      if (!indexName || indexName === popInfo.type || closeTyps.includes(indexName)) {
        AMapView.value.showInfoWin(false);

        // 地图移动，站点会自动重绘（解决弹窗关闭后，站点选中效果仍存在问题）
        AMapView.value.panBy(0.1,0.1);
      }
    };

    // 控制switch组件的是否显示/图例切换
    const switchCompContorl = () => {
      // 菜单切换，如果是在站点内部菜单进行切换，switch 组件中，插值图状态不变
      const isPMParentMenu = mapElementSelected.value.parent === 'pm' && mapElementSelected.value.isOMSP === true;

      switchControlRef.value.setLegend(mapElementSelected.value.type);
      if (!mapElementSelected.value.isOMSP) {
        switchControlRef.value.setSwitchIsShow(mapElementSelected.value.parent, isPMParentMenu);
      }
    };

    // 工具栏组件 切换要素后通信方法
    const mapElementChange = (toolsElementParams: any) => {
      mapElementSelected.value = toolsElementParams;
      if (mapElementSelected.value.isSelected) {
        showMarkerClusterers();
        isSelectedMenu.value = true;
        switchControlRef.value.setLegend(mapElementSelected.value.type);
      } else {
        isSelectedMenu.value = false;
        AMapView.value.clearMarkerClusterer('all');
        // switchControlRef.value.resetSwicthControl();
      }
      closeWinInfo(mapElementSelected.value.parent);
      //  选择不同的类型菜单，对右下角Switch中的组件显隐控制及图例切换
      switchCompContorl();
    };

    /**
     *  点击逐时列表行，查询热点网格及（右侧）行政区域数据
     * @param {any} rowClickData 表格行数据
     * @return {void}
     */
    const loadInitData = (rowClickData?: any) => {
      mapCheckGrid.value = {};
      mapChecked(); // 重置已选择的区域的详情与下标
      const { time, targetType, count, } = rowClickData;

      if (time) {
        const params = {
          issue: time,
          targetType,
          regionId: '320125000000',
        };

        title.value = `${moment(time, 'YYYYMMDDHH').format('YYYY年MM月DD日HH时')} ${targetType === 'pm2_5' ?
          'PM₂.₅' :
          'PM₁₀'}热点网格分布`;

        queryInfoByIssue(params).then((result: any) => {
          const res = result.data;

          if (res?.length) {
            closeOrCancel();
            const gridData = res.map((item: any, index: number) => ({ index, ...item, }));

            AMapView.value.drawHotGrid(gridData, (curGrid: any) => {
              showRightPanel.value = true;
              // 点击地图上选中网格数据集合
              mapCheckGrid.value = curGrid;
              // 重置已选择的数据详情与下标
              mapChecked();
              if (curGrid?.hotSpotDTOList) {
                selectCompany(curGrid.hotSpotDTOList);
              }
            });
            gridDetailData.value = res;
            gridDetailData.value.monitorTime = time;
            gridDetailData.value.total = count;
            gridDetailData.value.zhen = res[0].zhen;
            gridDetailData.value.company = res[0].company;
          }

          showRightPanel.value = true;
          mapWidth.mapRightWidth = '24.5%';
        });
      } else {
        // 左侧逐时列表无数据
        AMapView.value.removeHotGrid();
        title.value = '';
        gridDetailData.value = {};
        showRightPanel.value = false;
        mapWidth.mapRightWidth = '0';
      }
    };

    // 地图中心点根据左侧弹窗显隐变动
    const leftDialogHide = (flag: boolean) => {
      if (flag) {
        mapWidth.mapLeftWidth = '0';
      } else {
        mapWidth.mapLeftWidth = '23.98%';
      }
    };

    // 更新左侧逐时列表
    const updateLeftTable = () => {
      // 调用子组件loadGridData函数，更新左侧信息
      leftDialogVueRef.value.loadGridData();
    };

    // 关闭右侧网格详情
    const closeRightPanel = () => {
      activeGridIndex.value = -1;
      showRightPanel.value = false;
      mapWidth.mapRightWidth = '0';
      if (AMapView.value.rectangles?.length) {
        AMapView.value.rectangles.forEach((item: any) => {
          item.setOptions({
            fillOpacity: 0.2,
          });
        });
      }
      closeOrCancel();
    };

    /**
     *  点击右侧列表，选中某一个网格
     * @param {any} checkedGrid 某个选中网格信息
     * @return {void}
     */
    const gridDetailClick = ({ index, checkedGrid, }: any) => {
      activeGridIndex.value = index;
      if (AMapView.value.rectangles?.length) {
        AMapView.value.rectangles.forEach((item: any) => {
          item.setOptions({
            fillOpacity: 0.2,
          });
          if (item.getExtData().id === checkedGrid.id) {
            item.setOptions({
              fillOpacity: 1,
            });
          }
        });

        /*
         * 不缩放地图
         * AMapView.value.setFitView(AMapView.value.rectangles, false, [60,
         *   60,
         *   600,
         *   600,]);
         */

        if (checkedGrid?.hotSpotDTOList) {
          selectCompany(checkedGrid.hotSpotDTOList);
        }

        mapCheckGrid.value = checkedGrid;
        // 重置已选择的网格数据与下标
        mapChecked();
      }

      const { lon, lat, } = checkedGrid;

      if (Object.keys(AMapView.value)?.length) {
        AMapView.value.geocoder([lon, lat,], (val: string) => {
          if (val && activeGrid.value && Object.keys(activeGrid.value).indexOf('aaddress') === -1) {
            activeGrid.value = {
              ...checkedGrid,
              address: val,
            };
          }
        });
      }
    };

    /**
     *  点击右侧列表某一个网格中的tab（疑似企业/近三个月超标情况/工单详情）
     * @param {any} activeTab 某个选中tab（非疑似企业监控企业不标亮或不显示）
     * @return {void}
     */
    const tabClick = (activeTab: any) => {
      activeTabNum.value = activeTab;
      setTimeout(() => {
        if (mapCheckGrid.value?.hotSpotDTOList) {
          if (activeTab === 1) {
            selectCompany(mapCheckGrid.value?.hotSpotDTOList);
          } else {
            closeOrCancel();
          }
        }
      });
    };

    // 当前图层名称
    const currentMapLayer = ref<string>('vector');

    const layerFlag = ref<boolean>(true);

    // 切换地图底图
    const changeMap = (type: string) => {
      mapStyle.value = type;
      layerFlag.value = true;
      currentMapLayer.value = type;
      AMapView.value.changeMapStyle(type);
    };

    // 初始化地图弹窗
    const initWinInfo = () => {
      if (popupRef.value.popupRef) {
        AMapView.value.addInfoWin(popupRef.value.popupRef, [0, 0,]);
      }
    };

    // 点击监控企业按钮
    const allCompanyShow = () => {
      closeWinInfo();
      multipleDataCaches.company.isChecked = !multipleDataCaches.company.isChecked;
      if (allCompanyShowFlag.value) {
        AMapView.value.clearMarkerClusterer('company');
        multipleDataCaches.company.data = [];
        setTimeout(() => {
          if (mapCheckGrid.value?.hotSpotDTOList) {
            selectCompany(mapCheckGrid.value.hotSpotDTOList);
          }
        });
      } else {
        queryAllCompany().then((result: any) => {
          const res = result.data;

          if (res?.length) {
            multipleDataCaches.company.data = res;

            AMapView.value.showMarkerClusterer(
              mapElementSelected,
              res,
              'company',
              isClustererMarks.value,
              siteInfoShow
            );
            // 若右侧网格列表有选中，则相应点标记选中
            if (mapCheckGrid.value?.hotSpotDTOList) {
              selectCompany(mapCheckGrid.value.hotSpotDTOList);
            }
          }
        });
      }
      allCompanyShowFlag.value = !allCompanyShowFlag.value;
    };

    const showCompanyClusterers = () => {
      if (multipleDataCaches.company.isChecked) {
        AMapView.value.clearMarkerClusterer('company');
        closeWinInfo();
        AMapView.value.showMarkerClusterer(
          mapElementSelected,
          multipleDataCaches.company.data,
          'company',
          isClustererMarks.value,
          siteInfoShow
        );
      }
    };

    const renderPmData = () => {
      if (mapElementSelected.value) {
        showMarkerClusterers();
      } else {
        const param = {
          icon: 'icon-daikouzhao',
          param: 'pmPM25',
          parent: 'pm',
          type: 'PM25',
        };

        mapElementSelected.value = param;
        getPMList(param);
      }
    };

    // 初始化地图工具插件
    const initToolBar = () => {
      if (AMapView.value && Object.keys(AMapView.value).length) {
        AMapView.value.addMouseTool();
      }
    };

    // 点击测距
    const activeRuler = ref<boolean>(false);
    const rulerClick = () => {
      if (AMapView.value) {
        AMapView.value.handleMouse('rule');
      }
      // activeRuler.value = !activeRuler.value;
    };

    onMounted(() => {
      initAMap();
      initToolBar();
      initWinInfo();
      renderPmData();
      let area = '';

      if (regionLevel === 1) {
        area = country;
      } else if (regionLevel === 2) {
        area = city;
      } else if (regionLevel === 3) {
        area = county;
        if (area === '高淳县') {
          area = '高淳区';
        }
      }
      setTimeout(() => {
        fake(area);
      });
    });

    onUnmounted(() => {
      AMapView.value.clearMap();
      AMapView.value.clearInfoWindow();
      AMapView.value.destroy();
      window.onresize = null;
    });

    return {
      title,
      mapStyle,
      switchControlRef,
      showRightPanel,
      gridDetailData,
      currentMapLayer,
      layerFlag,
      mapCheckGrid,
      allCompanyShowFlag,
      leftDialogVueRef,
      rightDialogVueRef,
      AMapView,
      popupRef,
      activeGrid,
      activeGridIndex,
      isSelectedMenu,
      timePlayerTenMinsPerm,
      mapContainerWidth,
      mapWidth,
      activeRuler,
      loadInitData,
      leftDialogHide,
      changeMap,
      allCompanyShow,
      closeRightPanel,
      gridDetailClick,
      tabClick,
      switchChange,
      updateLeftTable,
      closeWinInfo,
      mapElementChange,
      rulerClick,
    };
  },
});
